"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerHeaderTitleClassNames: function() {
        return drawerHeaderTitleClassNames;
    },
    useDrawerHeaderTitleStyles_unstable: function() {
        return useDrawerHeaderTitleStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdialog = require("@fluentui/react-dialog");
const drawerHeaderTitleClassNames = {
    root: 'fui-DrawerHeaderTitle',
    heading: 'fui-DrawerHeaderTitle__heading',
    action: 'fui-DrawerHeaderTitle__action'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Brf1p80: "f1869bpl",
        Bt984gj: "f122n59",
        i8kkvl: "fsnqrgy"
    },
    action: {
        t21cq0: [
            "faqnl2i",
            "fd75udd"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1869bpl{justify-content:space-between;}",
        ".f122n59{align-items:center;}",
        ".fsnqrgy{column-gap:var(--spacingHorizontalS);}",
        ".faqnl2i{margin-right:calc(var(--spacingHorizontalS) * -1);}",
        ".fd75udd{margin-left:calc(var(--spacingHorizontalS) * -1);}"
    ]
});
const useDrawerHeaderTitleStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const { heading: root = {}, action, components } = state;
    (0, _reactdialog.useDialogTitleStyles_unstable)({
        components: {
            root: components.heading,
            action: components.action
        },
        root,
        action
    });
    state.root.className = (0, _react.mergeClasses)(drawerHeaderTitleClassNames.root, styles.root, state.root.className);
    if (state.heading) {
        state.heading.className = (0, _react.mergeClasses)(drawerHeaderTitleClassNames.heading, state.heading.className);
    }
    if (state.action) {
        state.action.className = (0, _react.mergeClasses)(drawerHeaderTitleClassNames.action, styles.action, state.action.className);
    }
    return state;
}; //# sourceMappingURL=useDrawerHeaderTitleStyles.styles.js.map
